import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import Ionicon from 'react-ionicons';
import { Colors } from '../constants';

const Bg = styled.div`
  background-color: ${props => props.theme.bg};
  height: 65px;
  margin: 0;
  padding: 0;
  width: 100%;
  position: relative;
  z-index: 1;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  color: ${props => props.theme.top.title};
  padding-top: 32px;
  align-items: center;
  justify-content: center;
`;

const Left = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 8px;
  width: 30px;
  height: 30px;
`;

const Title = styled.div`
  flex: 1;
  font-size: 17px;
  text-align: center;
`;

const Right = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 8px;
  width: 30px;
  height: 30px;
`;

const TopNavBar = ({
  theme, title, left, right, leftSize, rightSize,
}) => (
  <ThemeProvider theme={theme}>
    <Bg>
      <Inner>
        <Left>{left ? <Ionicon icon={left} fontSize={leftSize || '24px'} color={Colors.lightGray} /> : null}</Left>
        <Title>{title}</Title>
        <Right>{right ? <Ionicon icon={right} fontSize={rightSize || '24px'} color={Colors.lightGray} /> : null}</Right>
      </Inner>
    </Bg>
  </ThemeProvider>
);

export default withTheme(TopNavBar);



// WEBPACK FOOTER //
// ./src/components/TopNavBar.js